module.exports = __webpack_public_path__ + "assets/img/dailyTask-bottom-right-right.0fd6b493.png";